<div [formGroup]="parentForm">
    <ng-container *ngTemplateOutlet="innerTree; context: { children: tree.children }"></ng-container>
</div>

<ng-template #innerTree let-children="children">
    <ul class="internal-tree">
        <li *ngFor="let node of children">
            <ng-container *ngTemplateOutlet="valueContainer; context: { $implicit: node }"></ng-container>
            <ng-container *ngIf="node.hasChildren && node.isExpanded">
                <ng-container *ngTemplateOutlet="innerTree; context: { children: node.children }"></ng-container>
            </ng-container>
        </li>
    </ul>
</ng-template>

<ng-template #valueContainer let-node>
    <div class="value-container" [ngClass]="{ leaf: !node.hasChildren }" (click)="clickNode(node)">
        <span *ngIf="node.hasChildren" class="caret" [ngClass]="{ 'caret-down': node.isExpanded }"></span>
        <div *ngIf="!node.hasChildren" class="checkbox-container">
            <fa-icon *ngIf="node.selected" [icon]="faCheck" size="2x"></fa-icon>
        </div>
        <div *ngIf="node.hasChildren" class="checkbox-container has-children">
            <fa-icon *ngIf="node.selectedChildren.length > 0" [icon]="faCheck" size="2x"></fa-icon>
        </div>

        <label>{{ node.value }}</label>
        <div *ngIf="node.selected">
            <button class="btn pace-link" (click)="collapseAll()">Collapse</button>
        </div>
    </div>
</ng-template>
